import { loadAdultQuestionBank } from '../utils/adultQuestionBank';
// src/data/registry.js
// 统一管理不同测评的配置信息

export const ASSESSMENT_TYPES = {
  // 成人14心座 (HR版) - 对应 /interview
  'adult14_hr': {
    id: 'adult14_hr',
    name: '成人14心座 (HR)',
    title: 'TPES 人才测评',
    ageRange: { min: 14, max: 99 },
    totalQuestions: 140,
    formConfig: 'standard', // 标准表单
    outrep: 'career', // 赋能版
    // 动态加载数据函数
    loadData: async (lang, ageGroup, context = {}) => (
      await loadAdultQuestionBank({ ...context, defaultLang: lang })
    ).questions
  },

  // 成人14心座 (通用版) - 对应 /adult14
  'adult14': {
    id: 'adult14',
    name: '成人14心座',
    title: 'TPES 人才测评',
    ageRange: { min: 14, max: 99 },
    totalQuestions: 140,
    formConfig: 'standard',
    outrep: 'career', // 默认为赋能版，具体可根据需求调整
    // 复用 adult14 数据
    loadData: async (lang, ageGroup, context = {}) => (
      await loadAdultQuestionBank({ ...context, defaultLang: lang })
    ).questions
  },

  // 占位配置，待具体数据和路径确定后完善
  'child7': { 
    id: 'child7', 
    name: '儿童7心座', 
    title: 'TPES儿童性格測評',
    ageRange: { min: 3, max: 12 },
    totalQuestions: 63,
    formConfig: 'child',  
    outrep: 'child',
    loadData: async (lang) => {
      try {
        let data;
        switch (lang) {
          case 'zh-CN':
            data = await import('./child7/quizData-cn.js');
            break;
          case 'en':
            // data = await import('./child7/quizData-en.js');
            data = await import('./child7/quizData-cn.js'); // fallback
            break;
          case 'vi':
            // data = await import('./child7/quizData-vn.js');
            data = await import('./child7/quizData-cn.js'); // fallback
            break;
          default: // zh-TW
            data = await import('./child7/quizData-tw.js');
            break;
        }
        return data.quizData;
      } catch (error) {
        console.error(`Failed to load quiz data for child7 in language ${lang}:`, error);
        const fallback = await import('./child7/quizData-tw.js');
        return fallback.quizData;
      }
    }
  },

  // 青少年14心座
  'youth': { 
    id: 'youth', 
    name: '青春版(青少年14心座)', 
    title: 'TPES 青少年性格测评',
    ageRange: { min: 12, max: 18 },
    totalQuestions: 135,
    formConfig: 'child', // 使用与儿童版相同的简化表单
    outrep: 'youth',
    loadData: async (lang) => {
      try {
        let data;
        switch (lang) {
          case 'zh-CN':
            data = await import('./youth/quizData-cn.js');
            break;
          case 'en':
            // 暂无英文版，回退到繁体中文
            data = await import('./youth/quizData-tw.js'); 
            break;
          case 'vi':
            // 暂无越南文版，回退到繁体中文
            data = await import('./youth/quizData-tw.js'); 
            break;
          default: // zh-TW
            data = await import('./youth/quizData-tw.js');
            break;
        }
        return data.quizData;
      } catch (error) {
        console.error(`Failed to load quiz data for youth in language ${lang}:`, error);
        const fallback = await import('./youth/quizData-tw.js');
        return fallback.quizData;
      }
    }
  },
  
  // 多元智能测评
  'intelligent': {
    id: 'intelligent',
    name: '多元智能测评',
    title: 'TPES 多元智能测评',
    ageRange: { min: 3, max: 99 },
    questionCountByAgeGroup: {
      kid: 80,
      elementary: 80,
      junior: 88,
      high: 88,
      university: 88,
      community: 88,
    },
    getTotalQuestions(ageGroup) {
      return this.questionCountByAgeGroup[ageGroup] || 0;
    },
    formConfig: 'intelligent', // 需要年龄段选择
    outrep: 'intelligent',
    loadData: async (lang, ageGroup) => {
      try {
        let data;
        switch (lang) {
          case 'zh-CN':
            data = await import('./intelligent/quizData-cn.js');
            break;
          case 'en':
            data = await import('./intelligent/quizData-en.js');
            break;
          case 'vi':
            data = await import('./intelligent/quizData-cn.js'); // fallback
            break;
          default: // zh-TW
            data = await import('./intelligent/quizData-tw.js');
            break;
        }
        // 根据选择的 ageGroup (kid, elementary, junior, high, university, community) 返回对应的题库数组
        return data.quizData[ageGroup] || [];
      } catch (error) {
        console.error(`Failed to load quiz data for intelligent in language ${lang}:`, error);
        const fallback = await import('./intelligent/quizData-tw.js');
        return fallback.quizData[ageGroup] || [];
      }
    }
  },

};

export const getAssessmentConfig = (type) => {
  // 如果没有 type，或者 type 不存在，默认回退到 adult14_hr (保持兼容性)
  return ASSESSMENT_TYPES[type] || ASSESSMENT_TYPES['adult14_hr'];
};
